import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const baseUrl = 'https://play.qubit.ng'

export default new Vuex.Store({
  state: {
    loading: false,
    imgLoad: false,
    serialInfo: null,
    errorMsg: "",
    errorAck: "",
    img: "",
    uploadRes: "",
    sold: '',
    issued: ''
  },
  mutations: {
    serialInfo(state, serialData) {
      state.serialInfo = serialData;
    },
    isLoading(state, payload) {
      state.loading = payload;
    },
    errorMsg(state, err) {
      state.errorMsg = err;
    },
    errorAck(state, err) {
      state.errorAck = err;
    },
    img(state, payload) {
      state.img = payload;
    },
    imgLoading(state, payload) {
      state.imgLoad = payload;
    },
    uploadRes(state, payload) {
      state.uploadRes = payload;
    },
    soldStamp(state, payload) {
      state.sold = payload.sold.toLocaleString();
      state.issued = payload.issued.toLocaleString();
    }
  },
  actions: {
    resetState({ commit }) {
      commit("serialInfo", null);
      commit("errorMsg", "");
      commit("uploadRes", "");
    },
    fetchSerialApi({ commit }, serialNum) {
      const serialNumberRegex = /^\d{6}-\d{4}-\d{12}-\d{1}-\d{6}$/;

      commit("isLoading", true);
      commit("imgLoading", true);
      commit("serialInfo", null);
      commit("errorMsg", "");
      commit("errorAck", "");
      commit("img", "");
      if (serialNum === "") {
        commit("errorMsg", "You have not entered a value");
        commit("isLoading", false);
        setTimeout(() => {
          commit("errorMsg", "");
        }, 5000);
        return;
      }
      if (!serialNumberRegex.test(serialNum)) {
        commit("errorMsg", "Please, provide a valid Stamp Serial Number.");
        commit("isLoading", false);
        setTimeout(() => {
          commit("errorMsg", "");
        }, 5000);
        return;
      }
      commit("img", `${baseUrl}/v1/daemon/stamp/image/${serialNum}`);
      axios
        .get(`v1/daemon/stamp/info/${serialNum}`)
        .then(res => {
          commit("serialInfo", res.data);
          commit("isLoading", false);
        })
        .catch(err => {
          if (err.response.data.status === 1) {
            commit(
              "errorAck",
              "Your stamp has an acknowledgement... to see more information, you need to login"
            );
            commit("isLoading", false);
          }
          if (err.response.data.status === -1) {
            commit("errorMsg", err.response.data.message);
            commit("isLoading", false);
            setTimeout(() => {
              commit("errorMsg", "");
            }, 5000);
            return;
          }
        });
    },
    toggleImgLoader({ commit }) {
      commit("imgLoading", false);
    },
    toggleImg({ commit }) {
      commit("imgLoading", false);
      commit("img", "");
    },
    loadSoldStamp({ commit }) {
      axios.get('v1/daemon/design/summary').then(res => {
        commit("soldStamp", res.data.info);
      });      
    }
  },
  getters: {
    // serial (state) {
    //   return state.serialInfo.info.stamp;
    // },
    // serialImage (state) {
    //   return state.serialInfo.info.issuer.avatar
    // }
  }
});
